<template>
    <div class="flex items-center justify-center min-h-screen">
        <div class="text-xl">
            404 Page Not Found
        </div>
    </div>
</template>
<script setup lang="ts"></script>